import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
import Tabs from "./path/Tabs"; //页面横向导航
import Login from "./path/Login"; //登录验证
import Main from "./path/main"; 
export default new Vuex.Store({
  modules: {
    Tabs,
    Login,
    Main
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage, // 可以是localStorage或sessionStorage
  })]
});
